/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Wed, 20 May 2026 17:45:15 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import {
  BeneficiaryType,
  BusinessAddress,
  BusinessContact,
  BusinessDomain,
  BusinessDomainAddress,
  BusinessDomainContact,
  BusinessInfo,
  BusinessOperations,
  Customer,
  CustomerBusinessOperationsCustomers,
  CustomerBusinessOperationsCustomersPatchRequest,
  CustomerBusinessOperationsFundsSource,
  CustomerBusinessOperationsFundsSourcePatchRequest,
  CustomerBusinessOperationsProfile,
  CustomerBusinessOperationsProfilePatchRequest,
  CustomerCompanyDetails,
  CustomerCompanyDetailsPatchRequest,
  CustomerDocuments,
  CustomerDocumentType,
  CustomerIndustryType,
  CustomerOrganizationContact,
  CustomerOrganizationContactPatchRequest,
  CustomerOrganizationLegalRepresentative,
  CustomerOrganizationLegalRepresentativePatchRequest,
  CustomerOrganizationOwners,
  CustomerOrganizationOwnersPatchRequest,
  CustomerProfilePatchRequestBase,
  CustomerSliceType,
  CustomerSocialNetwork,
  CustomerSocialNetworkPatchRequest,
  CustomerUserPersonalInfoPatchRequest,
  EntityType,
  IndustryType,
  LegalRepresentative,
  OccupationType,
  OperationsCustomers,
  OperationsFundsSource,
  OperationsProfile,
  Organization,
  Owner,
  SocialNetwork,
  WealthSourceType,
} from '@/types/customer';
import {
  isArrayOfString,
  isArrayOfStringOrNull,
  isBoolean,
  isBooleanOrNull,
  isNumberOrNull,
  isString,
  isStringOrNull,
} from '@/types/common-type-guards';
import { isArrayOfPermission } from '@/types/permissions.ext';

const valuesOfCustomerSliceType: readonly string[] = [
  'companyDetails',
  'businessOperationsProfile',
  'businessOperationsCustomers',
  'businessOperationsFundsSource',
  'userPersonalInfo',
  'organizationLegalRepresentative',
  'organizationContact',
  'socialNetwork',
  'organizationOwners',
];

export const isCustomerSliceType = (value: unknown): value is CustomerSliceType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCustomerSliceType.includes(value);
};

export const isCustomerSliceTypeOrNull = (value: unknown): value is CustomerSliceType | null => {
  return value === null || isCustomerSliceType(value);
};

export const isArrayOfCustomerSliceType = (value: unknown): value is CustomerSliceType[] => {
  return Array.isArray(value) && value.every(isCustomerSliceType);
};

export const isArrayOfCustomerSliceTypeOrNull = (
  value: unknown,
): value is CustomerSliceType[] | null => {
  return value === null || isArrayOfCustomerSliceType(value);
};

const valuesOfEntityType: readonly string[] = [
  'MICRO_EMPREENDEDOR_INDIVIDUAL_MEI',
  'EMPRESA_INDIVIDUAL_EI',
  'SOCIEDADE_LIMITADA_UNIPESSOAL_SLU',
  'SOCIEDADE_LIMITADA_EMPRESARIAL_LTDA',
  'SOCIEDADE_SIMPLES_SS',
  'SOCIEDADE_ANONIMA_SA',
];

export const isEntityType = (value: unknown): value is EntityType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfEntityType.includes(value);
};

export const isEntityTypeOrNull = (value: unknown): value is EntityType | null => {
  return value === null || isEntityType(value);
};

export const isArrayOfEntityType = (value: unknown): value is EntityType[] => {
  return Array.isArray(value) && value.every(isEntityType);
};

export const isArrayOfEntityTypeOrNull = (value: unknown): value is EntityType[] | null => {
  return value === null || isArrayOfEntityType(value);
};

const valuesOfIndustryType: readonly string[] = [
  'ENERGY_OIL_GAS_FUELS',
  'MATERIALS_COMMODITIES',
  'MANUFACTURING_CONSTRUCTION',
  'PROFESSIONAL_SERVICES',
  'MEDICAL_SERVICES',
  'TRANSPORTATION',
  'TRAVEL_LEISURE',
  'PHARMACEUTICALS',
  'FOOD_BEVERAGE',
  'ENTERTAINMENT',
  'GAMBLING',
  'CRYPTO_WEB3',
  'BANKS_INSURANCE_FINANCIAL',
  'IT_SOFTWARE',
  'TELECOM',
  'UTILITIES',
  'AGE_RESTRICTED',
  'OTHER',
];

export const isIndustryType = (value: unknown): value is IndustryType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfIndustryType.includes(value);
};

export const isIndustryTypeOrNull = (value: unknown): value is IndustryType | null => {
  return value === null || isIndustryType(value);
};

export const isArrayOfIndustryType = (value: unknown): value is IndustryType[] => {
  return Array.isArray(value) && value.every(isIndustryType);
};

export const isArrayOfIndustryTypeOrNull = (value: unknown): value is IndustryType[] | null => {
  return value === null || isArrayOfIndustryType(value);
};

const valuesOfOccupationType: readonly string[] = [
  'executive',
  'sales',
  'consulting',
  'government',
  'healthcare',
  'financeAccounting',
  'technology',
  'scienceEngineering',
  'foodServices',
  'legalServices',
  'manufacturing',
  'other',
];

export const isOccupationType = (value: unknown): value is OccupationType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfOccupationType.includes(value);
};

export const isOccupationTypeOrNull = (value: unknown): value is OccupationType | null => {
  return value === null || isOccupationType(value);
};

export const isArrayOfOccupationType = (value: unknown): value is OccupationType[] => {
  return Array.isArray(value) && value.every(isOccupationType);
};

export const isArrayOfOccupationTypeOrNull = (value: unknown): value is OccupationType[] | null => {
  return value === null || isArrayOfOccupationType(value);
};

const valuesOfWealthSourceType: readonly string[] = [
  'salary',
  'selfEmployed',
  'inheritance',
  'familySupport',
  'investments',
  'retirement',
  'rentalIncome',
  'governmentBenefits',
  'businessSale',
  'other',
];

export const isWealthSourceType = (value: unknown): value is WealthSourceType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfWealthSourceType.includes(value);
};

export const isWealthSourceTypeOrNull = (value: unknown): value is WealthSourceType | null => {
  return value === null || isWealthSourceType(value);
};

export const isArrayOfWealthSourceType = (value: unknown): value is WealthSourceType[] => {
  return Array.isArray(value) && value.every(isWealthSourceType);
};

export const isArrayOfWealthSourceTypeOrNull = (
  value: unknown,
): value is WealthSourceType[] | null => {
  return value === null || isArrayOfWealthSourceType(value);
};

const valuesOfCustomerIndustryType: readonly string[] = [
  'FIREARMS',
  'GAMBLING',
  'FOREIGN_NGOS',
  'CANNABIS',
  'ADULT',
  'METALS',
  'NONE',
];

export const isCustomerIndustryType = (value: unknown): value is CustomerIndustryType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCustomerIndustryType.includes(value);
};

export const isCustomerIndustryTypeOrNull = (
  value: unknown,
): value is CustomerIndustryType | null => {
  return value === null || isCustomerIndustryType(value);
};

export const isArrayOfCustomerIndustryType = (value: unknown): value is CustomerIndustryType[] => {
  return Array.isArray(value) && value.every(isCustomerIndustryType);
};

export const isArrayOfCustomerIndustryTypeOrNull = (
  value: unknown,
): value is CustomerIndustryType[] | null => {
  return value === null || isArrayOfCustomerIndustryType(value);
};

const valuesOfBeneficiaryType: readonly string[] = ['INDIVIDUAL', 'BUSINESS'];

export const isBeneficiaryType = (value: unknown): value is BeneficiaryType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfBeneficiaryType.includes(value);
};

export const isBeneficiaryTypeOrNull = (value: unknown): value is BeneficiaryType | null => {
  return value === null || isBeneficiaryType(value);
};

export const isArrayOfBeneficiaryType = (value: unknown): value is BeneficiaryType[] => {
  return Array.isArray(value) && value.every(isBeneficiaryType);
};

export const isArrayOfBeneficiaryTypeOrNull = (
  value: unknown,
): value is BeneficiaryType[] | null => {
  return value === null || isArrayOfBeneficiaryType(value);
};

const valuesOfCustomerDocumentType: readonly string[] = [
  'incorporation',
  'cnpjRegistration',
  'powerOfAttorney',
  'bankAccountStatement',
];

export const isCustomerDocumentType = (value: unknown): value is CustomerDocumentType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCustomerDocumentType.includes(value);
};

export const isCustomerDocumentTypeOrNull = (
  value: unknown,
): value is CustomerDocumentType | null => {
  return value === null || isCustomerDocumentType(value);
};

export const isArrayOfCustomerDocumentType = (value: unknown): value is CustomerDocumentType[] => {
  return Array.isArray(value) && value.every(isCustomerDocumentType);
};

export const isArrayOfCustomerDocumentTypeOrNull = (
  value: unknown,
): value is CustomerDocumentType[] | null => {
  return value === null || isArrayOfCustomerDocumentType(value);
};

export const isCustomerProfilePatchRequestBase = (
  value: unknown,
): value is CustomerProfilePatchRequestBase => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && isCustomerSliceType(value.type))) return false;

  return true;
};

export const isCustomerProfilePatchRequestBaseOrNull = (
  value: unknown,
): value is CustomerProfilePatchRequestBase | null => {
  return value === null || isCustomerProfilePatchRequestBase(value);
};

export const isArrayOfCustomerProfilePatchRequestBase = (
  value: unknown,
): value is readonly CustomerProfilePatchRequestBase[] => {
  return Array.isArray(value) && value.every(isCustomerProfilePatchRequestBase);
};

export const isArrayOfCustomerProfilePatchRequestBaseOrNull = (
  value: unknown,
): value is readonly CustomerProfilePatchRequestBase[] | null => {
  return value === null || isArrayOfCustomerProfilePatchRequestBase(value);
};

const propertiesOfCustomerProfilePatchRequestBase: readonly string[] = ['type'];

export const isKeyOfCustomerProfilePatchRequestBase = (
  value: unknown,
): value is keyof CustomerProfilePatchRequestBase => {
  return typeof value === 'string' && propertiesOfCustomerProfilePatchRequestBase.includes(value);
};

export const isBusinessAddress = (value: unknown): value is BusinessAddress => {
  if (value === null || typeof value !== 'object') return false;
  if (!('streetAddress' in value && isStringOrNull(value.streetAddress))) return false;
  if (!('complement' in value && isStringOrNull(value.complement))) return false;
  if (!('state' in value && isStringOrNull(value.state))) return false;
  if (!('city' in value && isStringOrNull(value.city))) return false;
  if (!('zipCode' in value && isNumberOrNull(value.zipCode))) return false;
  if ('country' in value && !isStringOrNull(value.country)) return false;

  return true;
};

export const isBusinessAddressOrNull = (value: unknown): value is BusinessAddress | null => {
  return value === null || isBusinessAddress(value);
};

export const isArrayOfBusinessAddress = (value: unknown): value is readonly BusinessAddress[] => {
  return Array.isArray(value) && value.every(isBusinessAddress);
};

export const isArrayOfBusinessAddressOrNull = (
  value: unknown,
): value is readonly BusinessAddress[] | null => {
  return value === null || isArrayOfBusinessAddress(value);
};

const propertiesOfBusinessAddress: readonly string[] = [
  'streetAddress',
  'complement',
  'state',
  'city',
  'zipCode',
  'country',
];

export const isKeyOfBusinessAddress = (value: unknown): value is keyof BusinessAddress => {
  return typeof value === 'string' && propertiesOfBusinessAddress.includes(value);
};

export const isOwner = (value: unknown): value is Owner => {
  if (value === null || typeof value !== 'object') return false;
  if (!('firstName' in value && isStringOrNull(value.firstName))) return false;
  if (!('lastName' in value && isStringOrNull(value.lastName))) return false;
  if (!('share' in value && isNumberOrNull(value.share))) return false;
  if (!('address' in value && isBusinessAddressOrNull(value.address))) return false;
  if (!('document' in value && isStringOrNull(value.document))) return false;
  if (!('sourceOfWealth' in value && isWealthSourceTypeOrNull(value.sourceOfWealth))) return false;
  if (!('occupation' in value && isOccupationTypeOrNull(value.occupation))) return false;
  if (!('annualIncome' in value && isNumberOrNull(value.annualIncome))) return false;

  return true;
};

export const isOwnerOrNull = (value: unknown): value is Owner | null => {
  return value === null || isOwner(value);
};

export const isArrayOfOwner = (value: unknown): value is readonly Owner[] => {
  return Array.isArray(value) && value.every(isOwner);
};

export const isArrayOfOwnerOrNull = (value: unknown): value is readonly Owner[] | null => {
  return value === null || isArrayOfOwner(value);
};

const propertiesOfOwner: readonly string[] = [
  'firstName',
  'lastName',
  'share',
  'address',
  'document',
  'sourceOfWealth',
  'occupation',
  'annualIncome',
];

export const isKeyOfOwner = (value: unknown): value is keyof Owner => {
  return typeof value === 'string' && propertiesOfOwner.includes(value);
};

export const isCustomerCompanyDetailsPatchRequest = (
  value: unknown,
): value is CustomerCompanyDetailsPatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.companyDetails)) return false;
  if (!('commercialName' in value && isStringOrNull(value.commercialName))) return false;
  if (!('legalEntityName' in value && isStringOrNull(value.legalEntityName))) return false;
  if (!('entityType' in value && isEntityTypeOrNull(value.entityType))) return false;
  if (!('taxId' in value && isStringOrNull(value.taxId))) return false;
  if (!('address' in value && isBusinessAddressOrNull(value.address))) return false;
  if (!('operationStartDate' in value && isStringOrNull(value.operationStartDate))) return false;

  return true;
};

export const isCustomerCompanyDetailsPatchRequestOrNull = (
  value: unknown,
): value is CustomerCompanyDetailsPatchRequest | null => {
  return value === null || isCustomerCompanyDetailsPatchRequest(value);
};

export const isArrayOfCustomerCompanyDetailsPatchRequest = (
  value: unknown,
): value is readonly CustomerCompanyDetailsPatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerCompanyDetailsPatchRequest);
};

export const isArrayOfCustomerCompanyDetailsPatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerCompanyDetailsPatchRequest[] | null => {
  return value === null || isArrayOfCustomerCompanyDetailsPatchRequest(value);
};

const propertiesOfCustomerCompanyDetailsPatchRequest: readonly string[] = [
  'type',
  'commercialName',
  'legalEntityName',
  'entityType',
  'taxId',
  'address',
  'operationStartDate',
];

export const isKeyOfCustomerCompanyDetailsPatchRequest = (
  value: unknown,
): value is keyof CustomerCompanyDetailsPatchRequest => {
  return (
    typeof value === 'string' && propertiesOfCustomerCompanyDetailsPatchRequest.includes(value)
  );
};

export const isCustomerCompanyDetails = (value: unknown): value is CustomerCompanyDetails => {
  if (value === null || typeof value !== 'object') return false;
  if (!('commercialName' in value && isStringOrNull(value.commercialName))) return false;
  if (!('legalEntityName' in value && isStringOrNull(value.legalEntityName))) return false;
  if (!('entityType' in value && isEntityTypeOrNull(value.entityType))) return false;
  if (!('taxId' in value && isStringOrNull(value.taxId))) return false;
  if (!('address' in value && isBusinessAddressOrNull(value.address))) return false;
  if (!('operationStartDate' in value && isStringOrNull(value.operationStartDate))) return false;

  return true;
};

export const isCustomerCompanyDetailsOrNull = (
  value: unknown,
): value is CustomerCompanyDetails | null => {
  return value === null || isCustomerCompanyDetails(value);
};

export const isArrayOfCustomerCompanyDetails = (
  value: unknown,
): value is readonly CustomerCompanyDetails[] => {
  return Array.isArray(value) && value.every(isCustomerCompanyDetails);
};

export const isArrayOfCustomerCompanyDetailsOrNull = (
  value: unknown,
): value is readonly CustomerCompanyDetails[] | null => {
  return value === null || isArrayOfCustomerCompanyDetails(value);
};

const propertiesOfCustomerCompanyDetails: readonly string[] = [
  'commercialName',
  'legalEntityName',
  'entityType',
  'taxId',
  'address',
  'operationStartDate',
];

export const isKeyOfCustomerCompanyDetails = (
  value: unknown,
): value is keyof CustomerCompanyDetails => {
  return typeof value === 'string' && propertiesOfCustomerCompanyDetails.includes(value);
};

export const isCustomerBusinessOperationsProfilePatchRequest = (
  value: unknown,
): value is CustomerBusinessOperationsProfilePatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.businessOperationsProfile))
    return false;
  if (!('industry' in value && isIndustryTypeOrNull(value.industry))) return false;
  if (!('services' in value && isStringOrNull(value.services))) return false;
  if (!('countries' in value && isArrayOfStringOrNull(value.countries))) return false;
  if (!('isFinancialInstitution' in value && isBooleanOrNull(value.isFinancialInstitution)))
    return false;
  if (
    !('hasBrazilLicenseRequirement' in value && isBooleanOrNull(value.hasBrazilLicenseRequirement))
  )
    return false;

  return true;
};

export const isCustomerBusinessOperationsProfilePatchRequestOrNull = (
  value: unknown,
): value is CustomerBusinessOperationsProfilePatchRequest | null => {
  return value === null || isCustomerBusinessOperationsProfilePatchRequest(value);
};

export const isArrayOfCustomerBusinessOperationsProfilePatchRequest = (
  value: unknown,
): value is readonly CustomerBusinessOperationsProfilePatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerBusinessOperationsProfilePatchRequest);
};

export const isArrayOfCustomerBusinessOperationsProfilePatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerBusinessOperationsProfilePatchRequest[] | null => {
  return value === null || isArrayOfCustomerBusinessOperationsProfilePatchRequest(value);
};

const propertiesOfCustomerBusinessOperationsProfilePatchRequest: readonly string[] = [
  'type',
  'industry',
  'services',
  'countries',
  'isFinancialInstitution',
  'hasBrazilLicenseRequirement',
];

export const isKeyOfCustomerBusinessOperationsProfilePatchRequest = (
  value: unknown,
): value is keyof CustomerBusinessOperationsProfilePatchRequest => {
  return (
    typeof value === 'string' &&
    propertiesOfCustomerBusinessOperationsProfilePatchRequest.includes(value)
  );
};

export const isCustomerBusinessOperationsProfile = (
  value: unknown,
): value is CustomerBusinessOperationsProfile => {
  if (value === null || typeof value !== 'object') return false;
  if (!('industry' in value && isIndustryTypeOrNull(value.industry))) return false;
  if (!('subcategories' in value && isArrayOfStringOrNull(value.subcategories))) return false;
  if (!('services' in value && isStringOrNull(value.services))) return false;
  if (!('countries' in value && isArrayOfStringOrNull(value.countries))) return false;
  if (!('isFinancialInstitution' in value && isBooleanOrNull(value.isFinancialInstitution)))
    return false;
  if (
    !('hasBrazilLicenseRequirement' in value && isBooleanOrNull(value.hasBrazilLicenseRequirement))
  )
    return false;

  return true;
};

export const isCustomerBusinessOperationsProfileOrNull = (
  value: unknown,
): value is CustomerBusinessOperationsProfile | null => {
  return value === null || isCustomerBusinessOperationsProfile(value);
};

export const isArrayOfCustomerBusinessOperationsProfile = (
  value: unknown,
): value is readonly CustomerBusinessOperationsProfile[] => {
  return Array.isArray(value) && value.every(isCustomerBusinessOperationsProfile);
};

export const isArrayOfCustomerBusinessOperationsProfileOrNull = (
  value: unknown,
): value is readonly CustomerBusinessOperationsProfile[] | null => {
  return value === null || isArrayOfCustomerBusinessOperationsProfile(value);
};

const propertiesOfCustomerBusinessOperationsProfile: readonly string[] = [
  'industry',
  'subcategories',
  'services',
  'countries',
  'isFinancialInstitution',
  'hasBrazilLicenseRequirement',
];

export const isKeyOfCustomerBusinessOperationsProfile = (
  value: unknown,
): value is keyof CustomerBusinessOperationsProfile => {
  return typeof value === 'string' && propertiesOfCustomerBusinessOperationsProfile.includes(value);
};

export const isCustomerBusinessOperationsCustomersPatchRequest = (
  value: unknown,
): value is CustomerBusinessOperationsCustomersPatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.businessOperationsCustomers))
    return false;
  if (!('customerType' in value && isArrayOfBeneficiaryTypeOrNull(value.customerType)))
    return false;
  if (!('typicalCustomer' in value && isStringOrNull(value.typicalCustomer))) return false;
  if (!('countries' in value && isArrayOfStringOrNull(value.countries))) return false;
  if (!('quantity' in value && isNumberOrNull(value.quantity))) return false;
  if ('industries' in value && !isArrayOfCustomerIndustryTypeOrNull(value.industries)) return false;

  return true;
};

export const isCustomerBusinessOperationsCustomersPatchRequestOrNull = (
  value: unknown,
): value is CustomerBusinessOperationsCustomersPatchRequest | null => {
  return value === null || isCustomerBusinessOperationsCustomersPatchRequest(value);
};

export const isArrayOfCustomerBusinessOperationsCustomersPatchRequest = (
  value: unknown,
): value is readonly CustomerBusinessOperationsCustomersPatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerBusinessOperationsCustomersPatchRequest);
};

export const isArrayOfCustomerBusinessOperationsCustomersPatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerBusinessOperationsCustomersPatchRequest[] | null => {
  return value === null || isArrayOfCustomerBusinessOperationsCustomersPatchRequest(value);
};

const propertiesOfCustomerBusinessOperationsCustomersPatchRequest: readonly string[] = [
  'type',
  'customerType',
  'typicalCustomer',
  'countries',
  'quantity',
  'industries',
];

export const isKeyOfCustomerBusinessOperationsCustomersPatchRequest = (
  value: unknown,
): value is keyof CustomerBusinessOperationsCustomersPatchRequest => {
  return (
    typeof value === 'string' &&
    propertiesOfCustomerBusinessOperationsCustomersPatchRequest.includes(value)
  );
};

export const isCustomerBusinessOperationsCustomers = (
  value: unknown,
): value is CustomerBusinessOperationsCustomers => {
  if (value === null || typeof value !== 'object') return false;
  if (!('customerType' in value && isArrayOfBeneficiaryTypeOrNull(value.customerType)))
    return false;
  if (!('typicalCustomer' in value && isStringOrNull(value.typicalCustomer))) return false;
  if (!('countries' in value && isArrayOfStringOrNull(value.countries))) return false;
  if (!('quantity' in value && isNumberOrNull(value.quantity))) return false;
  if (!('industries' in value && isArrayOfCustomerIndustryTypeOrNull(value.industries)))
    return false;

  return true;
};

export const isCustomerBusinessOperationsCustomersOrNull = (
  value: unknown,
): value is CustomerBusinessOperationsCustomers | null => {
  return value === null || isCustomerBusinessOperationsCustomers(value);
};

export const isArrayOfCustomerBusinessOperationsCustomers = (
  value: unknown,
): value is readonly CustomerBusinessOperationsCustomers[] => {
  return Array.isArray(value) && value.every(isCustomerBusinessOperationsCustomers);
};

export const isArrayOfCustomerBusinessOperationsCustomersOrNull = (
  value: unknown,
): value is readonly CustomerBusinessOperationsCustomers[] | null => {
  return value === null || isArrayOfCustomerBusinessOperationsCustomers(value);
};

const propertiesOfCustomerBusinessOperationsCustomers: readonly string[] = [
  'customerType',
  'typicalCustomer',
  'countries',
  'quantity',
  'industries',
];

export const isKeyOfCustomerBusinessOperationsCustomers = (
  value: unknown,
): value is keyof CustomerBusinessOperationsCustomers => {
  return (
    typeof value === 'string' && propertiesOfCustomerBusinessOperationsCustomers.includes(value)
  );
};

export const isCustomerBusinessOperationsFundsSourcePatchRequest = (
  value: unknown,
): value is CustomerBusinessOperationsFundsSourcePatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.businessOperationsFundsSource))
    return false;
  if (!('thirdPartyBeneficiaries' in value && isBooleanOrNull(value.thirdPartyBeneficiaries)))
    return false;
  if (!('usdVolume' in value && isStringOrNull(value.usdVolume))) return false;

  return true;
};

export const isCustomerBusinessOperationsFundsSourcePatchRequestOrNull = (
  value: unknown,
): value is CustomerBusinessOperationsFundsSourcePatchRequest | null => {
  return value === null || isCustomerBusinessOperationsFundsSourcePatchRequest(value);
};

export const isArrayOfCustomerBusinessOperationsFundsSourcePatchRequest = (
  value: unknown,
): value is readonly CustomerBusinessOperationsFundsSourcePatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerBusinessOperationsFundsSourcePatchRequest);
};

export const isArrayOfCustomerBusinessOperationsFundsSourcePatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerBusinessOperationsFundsSourcePatchRequest[] | null => {
  return value === null || isArrayOfCustomerBusinessOperationsFundsSourcePatchRequest(value);
};

const propertiesOfCustomerBusinessOperationsFundsSourcePatchRequest: readonly string[] = [
  'type',
  'thirdPartyBeneficiaries',
  'usdVolume',
];

export const isKeyOfCustomerBusinessOperationsFundsSourcePatchRequest = (
  value: unknown,
): value is keyof CustomerBusinessOperationsFundsSourcePatchRequest => {
  return (
    typeof value === 'string' &&
    propertiesOfCustomerBusinessOperationsFundsSourcePatchRequest.includes(value)
  );
};

export const isCustomerBusinessOperationsFundsSource = (
  value: unknown,
): value is CustomerBusinessOperationsFundsSource => {
  if (value === null || typeof value !== 'object') return false;
  if (!('thirdPartyBeneficiaries' in value && isBooleanOrNull(value.thirdPartyBeneficiaries)))
    return false;
  if (!('usdVolume' in value && isStringOrNull(value.usdVolume))) return false;

  return true;
};

export const isCustomerBusinessOperationsFundsSourceOrNull = (
  value: unknown,
): value is CustomerBusinessOperationsFundsSource | null => {
  return value === null || isCustomerBusinessOperationsFundsSource(value);
};

export const isArrayOfCustomerBusinessOperationsFundsSource = (
  value: unknown,
): value is readonly CustomerBusinessOperationsFundsSource[] => {
  return Array.isArray(value) && value.every(isCustomerBusinessOperationsFundsSource);
};

export const isArrayOfCustomerBusinessOperationsFundsSourceOrNull = (
  value: unknown,
): value is readonly CustomerBusinessOperationsFundsSource[] | null => {
  return value === null || isArrayOfCustomerBusinessOperationsFundsSource(value);
};

const propertiesOfCustomerBusinessOperationsFundsSource: readonly string[] = [
  'thirdPartyBeneficiaries',
  'usdVolume',
];

export const isKeyOfCustomerBusinessOperationsFundsSource = (
  value: unknown,
): value is keyof CustomerBusinessOperationsFundsSource => {
  return (
    typeof value === 'string' && propertiesOfCustomerBusinessOperationsFundsSource.includes(value)
  );
};

export const isCustomerUserPersonalInfoPatchRequest = (
  value: unknown,
): value is CustomerUserPersonalInfoPatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.userPersonalInfo)) return false;
  if (!('firstName' in value && isStringOrNull(value.firstName))) return false;
  if (!('lastName' in value && isStringOrNull(value.lastName))) return false;

  return true;
};

export const isCustomerUserPersonalInfoPatchRequestOrNull = (
  value: unknown,
): value is CustomerUserPersonalInfoPatchRequest | null => {
  return value === null || isCustomerUserPersonalInfoPatchRequest(value);
};

export const isArrayOfCustomerUserPersonalInfoPatchRequest = (
  value: unknown,
): value is readonly CustomerUserPersonalInfoPatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerUserPersonalInfoPatchRequest);
};

export const isArrayOfCustomerUserPersonalInfoPatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerUserPersonalInfoPatchRequest[] | null => {
  return value === null || isArrayOfCustomerUserPersonalInfoPatchRequest(value);
};

const propertiesOfCustomerUserPersonalInfoPatchRequest: readonly string[] = [
  'type',
  'firstName',
  'lastName',
];

export const isKeyOfCustomerUserPersonalInfoPatchRequest = (
  value: unknown,
): value is keyof CustomerUserPersonalInfoPatchRequest => {
  return (
    typeof value === 'string' && propertiesOfCustomerUserPersonalInfoPatchRequest.includes(value)
  );
};

export const isCustomerOrganizationLegalRepresentative = (
  value: unknown,
): value is CustomerOrganizationLegalRepresentative => {
  if (value === null || typeof value !== 'object') return false;
  if (!('firstName' in value && isStringOrNull(value.firstName))) return false;
  if (!('lastName' in value && isStringOrNull(value.lastName))) return false;
  if (!('email' in value && isStringOrNull(value.email))) return false;
  if (!('phoneNumber' in value && isStringOrNull(value.phoneNumber))) return false;
  if (!('document' in value && isStringOrNull(value.document))) return false;

  return true;
};

export const isCustomerOrganizationLegalRepresentativeOrNull = (
  value: unknown,
): value is CustomerOrganizationLegalRepresentative | null => {
  return value === null || isCustomerOrganizationLegalRepresentative(value);
};

export const isArrayOfCustomerOrganizationLegalRepresentative = (
  value: unknown,
): value is readonly CustomerOrganizationLegalRepresentative[] => {
  return Array.isArray(value) && value.every(isCustomerOrganizationLegalRepresentative);
};

export const isArrayOfCustomerOrganizationLegalRepresentativeOrNull = (
  value: unknown,
): value is readonly CustomerOrganizationLegalRepresentative[] | null => {
  return value === null || isArrayOfCustomerOrganizationLegalRepresentative(value);
};

const propertiesOfCustomerOrganizationLegalRepresentative: readonly string[] = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'document',
];

export const isKeyOfCustomerOrganizationLegalRepresentative = (
  value: unknown,
): value is keyof CustomerOrganizationLegalRepresentative => {
  return (
    typeof value === 'string' && propertiesOfCustomerOrganizationLegalRepresentative.includes(value)
  );
};

export const isCustomerOrganizationLegalRepresentativePatchRequest = (
  value: unknown,
): value is CustomerOrganizationLegalRepresentativePatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.organizationLegalRepresentative))
    return false;
  if (!('firstName' in value && isStringOrNull(value.firstName))) return false;
  if (!('lastName' in value && isStringOrNull(value.lastName))) return false;
  if (!('email' in value && isStringOrNull(value.email))) return false;
  if (!('phoneNumber' in value && isStringOrNull(value.phoneNumber))) return false;

  return true;
};

export const isCustomerOrganizationLegalRepresentativePatchRequestOrNull = (
  value: unknown,
): value is CustomerOrganizationLegalRepresentativePatchRequest | null => {
  return value === null || isCustomerOrganizationLegalRepresentativePatchRequest(value);
};

export const isArrayOfCustomerOrganizationLegalRepresentativePatchRequest = (
  value: unknown,
): value is readonly CustomerOrganizationLegalRepresentativePatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerOrganizationLegalRepresentativePatchRequest);
};

export const isArrayOfCustomerOrganizationLegalRepresentativePatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerOrganizationLegalRepresentativePatchRequest[] | null => {
  return value === null || isArrayOfCustomerOrganizationLegalRepresentativePatchRequest(value);
};

const propertiesOfCustomerOrganizationLegalRepresentativePatchRequest: readonly string[] = [
  'type',
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
];

export const isKeyOfCustomerOrganizationLegalRepresentativePatchRequest = (
  value: unknown,
): value is keyof CustomerOrganizationLegalRepresentativePatchRequest => {
  return (
    typeof value === 'string' &&
    propertiesOfCustomerOrganizationLegalRepresentativePatchRequest.includes(value)
  );
};

export const isCustomerOrganizationContactPatchRequest = (
  value: unknown,
): value is CustomerOrganizationContactPatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.organizationContact)) return false;
  if (!('firstName' in value && isStringOrNull(value.firstName))) return false;
  if (!('lastName' in value && isStringOrNull(value.lastName))) return false;
  if (!('email' in value && isStringOrNull(value.email))) return false;
  if (!('phoneNumber' in value && isStringOrNull(value.phoneNumber))) return false;
  if (!('position' in value && isStringOrNull(value.position))) return false;

  return true;
};

export const isCustomerOrganizationContactPatchRequestOrNull = (
  value: unknown,
): value is CustomerOrganizationContactPatchRequest | null => {
  return value === null || isCustomerOrganizationContactPatchRequest(value);
};

export const isArrayOfCustomerOrganizationContactPatchRequest = (
  value: unknown,
): value is readonly CustomerOrganizationContactPatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerOrganizationContactPatchRequest);
};

export const isArrayOfCustomerOrganizationContactPatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerOrganizationContactPatchRequest[] | null => {
  return value === null || isArrayOfCustomerOrganizationContactPatchRequest(value);
};

const propertiesOfCustomerOrganizationContactPatchRequest: readonly string[] = [
  'type',
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'position',
];

export const isKeyOfCustomerOrganizationContactPatchRequest = (
  value: unknown,
): value is keyof CustomerOrganizationContactPatchRequest => {
  return (
    typeof value === 'string' && propertiesOfCustomerOrganizationContactPatchRequest.includes(value)
  );
};

export const isCustomerOrganizationContact = (
  value: unknown,
): value is CustomerOrganizationContact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('firstName' in value && isStringOrNull(value.firstName))) return false;
  if (!('lastName' in value && isStringOrNull(value.lastName))) return false;
  if (!('email' in value && isStringOrNull(value.email))) return false;
  if (!('phoneNumber' in value && isStringOrNull(value.phoneNumber))) return false;
  if (!('position' in value && isStringOrNull(value.position))) return false;

  return true;
};

export const isCustomerOrganizationContactOrNull = (
  value: unknown,
): value is CustomerOrganizationContact | null => {
  return value === null || isCustomerOrganizationContact(value);
};

export const isArrayOfCustomerOrganizationContact = (
  value: unknown,
): value is readonly CustomerOrganizationContact[] => {
  return Array.isArray(value) && value.every(isCustomerOrganizationContact);
};

export const isArrayOfCustomerOrganizationContactOrNull = (
  value: unknown,
): value is readonly CustomerOrganizationContact[] | null => {
  return value === null || isArrayOfCustomerOrganizationContact(value);
};

const propertiesOfCustomerOrganizationContact: readonly string[] = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'position',
];

export const isKeyOfCustomerOrganizationContact = (
  value: unknown,
): value is keyof CustomerOrganizationContact => {
  return typeof value === 'string' && propertiesOfCustomerOrganizationContact.includes(value);
};

export const isCustomerSocialNetworkPatchRequest = (
  value: unknown,
): value is CustomerSocialNetworkPatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.socialNetwork)) return false;
  if (!('website' in value && isStringOrNull(value.website))) return false;
  if (!('socialMediaNetworks' in value && isArrayOfStringOrNull(value.socialMediaNetworks)))
    return false;

  return true;
};

export const isCustomerSocialNetworkPatchRequestOrNull = (
  value: unknown,
): value is CustomerSocialNetworkPatchRequest | null => {
  return value === null || isCustomerSocialNetworkPatchRequest(value);
};

export const isArrayOfCustomerSocialNetworkPatchRequest = (
  value: unknown,
): value is readonly CustomerSocialNetworkPatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerSocialNetworkPatchRequest);
};

export const isArrayOfCustomerSocialNetworkPatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerSocialNetworkPatchRequest[] | null => {
  return value === null || isArrayOfCustomerSocialNetworkPatchRequest(value);
};

const propertiesOfCustomerSocialNetworkPatchRequest: readonly string[] = [
  'type',
  'website',
  'socialMediaNetworks',
];

export const isKeyOfCustomerSocialNetworkPatchRequest = (
  value: unknown,
): value is keyof CustomerSocialNetworkPatchRequest => {
  return typeof value === 'string' && propertiesOfCustomerSocialNetworkPatchRequest.includes(value);
};

export const isCustomerSocialNetwork = (value: unknown): value is CustomerSocialNetwork => {
  if (value === null || typeof value !== 'object') return false;
  if (!('website' in value && isStringOrNull(value.website))) return false;
  if (!('socialMediaNetworks' in value && isArrayOfStringOrNull(value.socialMediaNetworks)))
    return false;

  return true;
};

export const isCustomerSocialNetworkOrNull = (
  value: unknown,
): value is CustomerSocialNetwork | null => {
  return value === null || isCustomerSocialNetwork(value);
};

export const isArrayOfCustomerSocialNetwork = (
  value: unknown,
): value is readonly CustomerSocialNetwork[] => {
  return Array.isArray(value) && value.every(isCustomerSocialNetwork);
};

export const isArrayOfCustomerSocialNetworkOrNull = (
  value: unknown,
): value is readonly CustomerSocialNetwork[] | null => {
  return value === null || isArrayOfCustomerSocialNetwork(value);
};

const propertiesOfCustomerSocialNetwork: readonly string[] = ['website', 'socialMediaNetworks'];

export const isKeyOfCustomerSocialNetwork = (
  value: unknown,
): value is keyof CustomerSocialNetwork => {
  return typeof value === 'string' && propertiesOfCustomerSocialNetwork.includes(value);
};

export const isCustomerOrganizationOwnersPatchRequest = (
  value: unknown,
): value is CustomerOrganizationOwnersPatchRequest => {
  if (value === null || typeof value !== 'object') return false;
  if (!('type' in value && value.type === CustomerSliceType.organizationOwners)) return false;
  if (!('owners' in value && isArrayOfOwnerOrNull(value.owners))) return false;

  return true;
};

export const isCustomerOrganizationOwnersPatchRequestOrNull = (
  value: unknown,
): value is CustomerOrganizationOwnersPatchRequest | null => {
  return value === null || isCustomerOrganizationOwnersPatchRequest(value);
};

export const isArrayOfCustomerOrganizationOwnersPatchRequest = (
  value: unknown,
): value is readonly CustomerOrganizationOwnersPatchRequest[] => {
  return Array.isArray(value) && value.every(isCustomerOrganizationOwnersPatchRequest);
};

export const isArrayOfCustomerOrganizationOwnersPatchRequestOrNull = (
  value: unknown,
): value is readonly CustomerOrganizationOwnersPatchRequest[] | null => {
  return value === null || isArrayOfCustomerOrganizationOwnersPatchRequest(value);
};

const propertiesOfCustomerOrganizationOwnersPatchRequest: readonly string[] = ['type', 'owners'];

export const isKeyOfCustomerOrganizationOwnersPatchRequest = (
  value: unknown,
): value is keyof CustomerOrganizationOwnersPatchRequest => {
  return (
    typeof value === 'string' && propertiesOfCustomerOrganizationOwnersPatchRequest.includes(value)
  );
};

export const isCustomerOrganizationOwners = (
  value: unknown,
): value is CustomerOrganizationOwners => {
  if (value === null || typeof value !== 'object') return false;
  if (!('owners' in value && isArrayOfOwnerOrNull(value.owners))) return false;

  return true;
};

export const isCustomerOrganizationOwnersOrNull = (
  value: unknown,
): value is CustomerOrganizationOwners | null => {
  return value === null || isCustomerOrganizationOwners(value);
};

export const isArrayOfCustomerOrganizationOwners = (
  value: unknown,
): value is readonly CustomerOrganizationOwners[] => {
  return Array.isArray(value) && value.every(isCustomerOrganizationOwners);
};

export const isArrayOfCustomerOrganizationOwnersOrNull = (
  value: unknown,
): value is readonly CustomerOrganizationOwners[] | null => {
  return value === null || isArrayOfCustomerOrganizationOwners(value);
};

const propertiesOfCustomerOrganizationOwners: readonly string[] = ['owners'];

export const isKeyOfCustomerOrganizationOwners = (
  value: unknown,
): value is keyof CustomerOrganizationOwners => {
  return typeof value === 'string' && propertiesOfCustomerOrganizationOwners.includes(value);
};

export const isOperationsProfile = (value: unknown): value is OperationsProfile => {
  if (value === null || typeof value !== 'object') return false;
  if (!('industry' in value && isIndustryTypeOrNull(value.industry))) return false;
  if (!('subcategories' in value && isArrayOfStringOrNull(value.subcategories))) return false;
  if (!('services' in value && isStringOrNull(value.services))) return false;
  if (!('countries' in value && isArrayOfStringOrNull(value.countries))) return false;
  if (!('isFinancialInstitution' in value && isBooleanOrNull(value.isFinancialInstitution)))
    return false;
  if (
    !('hasBrazilLicenseRequirement' in value && isBooleanOrNull(value.hasBrazilLicenseRequirement))
  )
    return false;

  return true;
};

export const isOperationsProfileOrNull = (value: unknown): value is OperationsProfile | null => {
  return value === null || isOperationsProfile(value);
};

export const isArrayOfOperationsProfile = (
  value: unknown,
): value is readonly OperationsProfile[] => {
  return Array.isArray(value) && value.every(isOperationsProfile);
};

export const isArrayOfOperationsProfileOrNull = (
  value: unknown,
): value is readonly OperationsProfile[] | null => {
  return value === null || isArrayOfOperationsProfile(value);
};

const propertiesOfOperationsProfile: readonly string[] = [
  'industry',
  'subcategories',
  'services',
  'countries',
  'isFinancialInstitution',
  'hasBrazilLicenseRequirement',
];

export const isKeyOfOperationsProfile = (value: unknown): value is keyof OperationsProfile => {
  return typeof value === 'string' && propertiesOfOperationsProfile.includes(value);
};

export const isOperationsCustomers = (value: unknown): value is OperationsCustomers => {
  if (value === null || typeof value !== 'object') return false;
  if (!('customerType' in value && isArrayOfBeneficiaryTypeOrNull(value.customerType)))
    return false;
  if (!('typicalCustomer' in value && isStringOrNull(value.typicalCustomer))) return false;
  if (!('countries' in value && isArrayOfStringOrNull(value.countries))) return false;
  if (!('quantity' in value && isNumberOrNull(value.quantity))) return false;
  if (!('industries' in value && isArrayOfCustomerIndustryTypeOrNull(value.industries)))
    return false;

  return true;
};

export const isOperationsCustomersOrNull = (
  value: unknown,
): value is OperationsCustomers | null => {
  return value === null || isOperationsCustomers(value);
};

export const isArrayOfOperationsCustomers = (
  value: unknown,
): value is readonly OperationsCustomers[] => {
  return Array.isArray(value) && value.every(isOperationsCustomers);
};

export const isArrayOfOperationsCustomersOrNull = (
  value: unknown,
): value is readonly OperationsCustomers[] | null => {
  return value === null || isArrayOfOperationsCustomers(value);
};

const propertiesOfOperationsCustomers: readonly string[] = [
  'customerType',
  'typicalCustomer',
  'countries',
  'quantity',
  'industries',
];

export const isKeyOfOperationsCustomers = (value: unknown): value is keyof OperationsCustomers => {
  return typeof value === 'string' && propertiesOfOperationsCustomers.includes(value);
};

export const isOperationsFundsSource = (value: unknown): value is OperationsFundsSource => {
  if (value === null || typeof value !== 'object') return false;
  if (!('thirdPartyBeneficiaries' in value && isBooleanOrNull(value.thirdPartyBeneficiaries)))
    return false;
  if (!('usdVolume' in value && isStringOrNull(value.usdVolume))) return false;

  return true;
};

export const isOperationsFundsSourceOrNull = (
  value: unknown,
): value is OperationsFundsSource | null => {
  return value === null || isOperationsFundsSource(value);
};

export const isArrayOfOperationsFundsSource = (
  value: unknown,
): value is readonly OperationsFundsSource[] => {
  return Array.isArray(value) && value.every(isOperationsFundsSource);
};

export const isArrayOfOperationsFundsSourceOrNull = (
  value: unknown,
): value is readonly OperationsFundsSource[] | null => {
  return value === null || isArrayOfOperationsFundsSource(value);
};

const propertiesOfOperationsFundsSource: readonly string[] = [
  'thirdPartyBeneficiaries',
  'usdVolume',
];

export const isKeyOfOperationsFundsSource = (
  value: unknown,
): value is keyof OperationsFundsSource => {
  return typeof value === 'string' && propertiesOfOperationsFundsSource.includes(value);
};

export const isSocialNetwork = (value: unknown): value is SocialNetwork => {
  if (value === null || typeof value !== 'object') return false;
  if (!('website' in value && isString(value.website))) return false;
  if (!('socialMediaNetworks' in value && isArrayOfString(value.socialMediaNetworks))) return false;

  return true;
};

export const isSocialNetworkOrNull = (value: unknown): value is SocialNetwork | null => {
  return value === null || isSocialNetwork(value);
};

export const isArrayOfSocialNetwork = (value: unknown): value is readonly SocialNetwork[] => {
  return Array.isArray(value) && value.every(isSocialNetwork);
};

export const isArrayOfSocialNetworkOrNull = (
  value: unknown,
): value is readonly SocialNetwork[] | null => {
  return value === null || isArrayOfSocialNetwork(value);
};

const propertiesOfSocialNetwork: readonly string[] = ['website', 'socialMediaNetworks'];

export const isKeyOfSocialNetwork = (value: unknown): value is keyof SocialNetwork => {
  return typeof value === 'string' && propertiesOfSocialNetwork.includes(value);
};

export const isBusinessContact = (value: unknown): value is BusinessContact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('firstName' in value && isString(value.firstName))) return false;
  if (!('lastName' in value && isString(value.lastName))) return false;
  if (!('email' in value && isString(value.email))) return false;
  if (!('phoneNumber' in value && isString(value.phoneNumber))) return false;
  if (!('position' in value && isString(value.position))) return false;

  return true;
};

export const isBusinessContactOrNull = (value: unknown): value is BusinessContact | null => {
  return value === null || isBusinessContact(value);
};

export const isArrayOfBusinessContact = (value: unknown): value is readonly BusinessContact[] => {
  return Array.isArray(value) && value.every(isBusinessContact);
};

export const isArrayOfBusinessContactOrNull = (
  value: unknown,
): value is readonly BusinessContact[] | null => {
  return value === null || isArrayOfBusinessContact(value);
};

const propertiesOfBusinessContact: readonly string[] = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'position',
];

export const isKeyOfBusinessContact = (value: unknown): value is keyof BusinessContact => {
  return typeof value === 'string' && propertiesOfBusinessContact.includes(value);
};

export const isLegalRepresentative = (value: unknown): value is LegalRepresentative => {
  if (value === null || typeof value !== 'object') return false;
  if (!('firstName' in value && isString(value.firstName))) return false;
  if (!('lastName' in value && isString(value.lastName))) return false;
  if (!('email' in value && isString(value.email))) return false;
  if (!('phoneNumber' in value && isString(value.phoneNumber))) return false;
  if (!('document' in value && isStringOrNull(value.document))) return false;

  return true;
};

export const isLegalRepresentativeOrNull = (
  value: unknown,
): value is LegalRepresentative | null => {
  return value === null || isLegalRepresentative(value);
};

export const isArrayOfLegalRepresentative = (
  value: unknown,
): value is readonly LegalRepresentative[] => {
  return Array.isArray(value) && value.every(isLegalRepresentative);
};

export const isArrayOfLegalRepresentativeOrNull = (
  value: unknown,
): value is readonly LegalRepresentative[] | null => {
  return value === null || isArrayOfLegalRepresentative(value);
};

const propertiesOfLegalRepresentative: readonly string[] = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'document',
];

export const isKeyOfLegalRepresentative = (value: unknown): value is keyof LegalRepresentative => {
  return typeof value === 'string' && propertiesOfLegalRepresentative.includes(value);
};

export const isOrganization = (value: unknown): value is Organization => {
  if (value === null || typeof value !== 'object') return false;
  if (!('legalRepresentative' in value && isLegalRepresentativeOrNull(value.legalRepresentative)))
    return false;
  if (!('contact' in value && isBusinessContactOrNull(value.contact))) return false;
  if (!('owners' in value && isArrayOfOwnerOrNull(value.owners))) return false;

  return true;
};

export const isOrganizationOrNull = (value: unknown): value is Organization | null => {
  return value === null || isOrganization(value);
};

export const isArrayOfOrganization = (value: unknown): value is readonly Organization[] => {
  return Array.isArray(value) && value.every(isOrganization);
};

export const isArrayOfOrganizationOrNull = (
  value: unknown,
): value is readonly Organization[] | null => {
  return value === null || isArrayOfOrganization(value);
};

const propertiesOfOrganization: readonly string[] = ['legalRepresentative', 'contact', 'owners'];

export const isKeyOfOrganization = (value: unknown): value is keyof Organization => {
  return typeof value === 'string' && propertiesOfOrganization.includes(value);
};

export const isBusinessOperations = (value: unknown): value is BusinessOperations => {
  if (value === null || typeof value !== 'object') return false;
  if (!('profile' in value && isOperationsProfileOrNull(value.profile))) return false;
  if (!('customers' in value && isOperationsCustomersOrNull(value.customers))) return false;
  if (!('fundsSource' in value && isOperationsFundsSourceOrNull(value.fundsSource))) return false;

  return true;
};

export const isBusinessOperationsOrNull = (value: unknown): value is BusinessOperations | null => {
  return value === null || isBusinessOperations(value);
};

export const isArrayOfBusinessOperations = (
  value: unknown,
): value is readonly BusinessOperations[] => {
  return Array.isArray(value) && value.every(isBusinessOperations);
};

export const isArrayOfBusinessOperationsOrNull = (
  value: unknown,
): value is readonly BusinessOperations[] | null => {
  return value === null || isArrayOfBusinessOperations(value);
};

const propertiesOfBusinessOperations: readonly string[] = ['profile', 'customers', 'fundsSource'];

export const isKeyOfBusinessOperations = (value: unknown): value is keyof BusinessOperations => {
  return typeof value === 'string' && propertiesOfBusinessOperations.includes(value);
};

export const isCustomerDocuments = (value: unknown): value is CustomerDocuments => {
  if (value === null || typeof value !== 'object') return false;
  if (!('incorporation' in value && isStringOrNull(value.incorporation))) return false;
  if (!('cnpjRegistration' in value && isStringOrNull(value.cnpjRegistration))) return false;
  if (!('powerOfAttorney' in value && isStringOrNull(value.powerOfAttorney))) return false;
  if (!('bankAccountStatement' in value && isStringOrNull(value.bankAccountStatement)))
    return false;

  return true;
};

export const isCustomerDocumentsOrNull = (value: unknown): value is CustomerDocuments | null => {
  return value === null || isCustomerDocuments(value);
};

export const isArrayOfCustomerDocuments = (
  value: unknown,
): value is readonly CustomerDocuments[] => {
  return Array.isArray(value) && value.every(isCustomerDocuments);
};

export const isArrayOfCustomerDocumentsOrNull = (
  value: unknown,
): value is readonly CustomerDocuments[] | null => {
  return value === null || isArrayOfCustomerDocuments(value);
};

const propertiesOfCustomerDocuments: readonly string[] = [
  'incorporation',
  'cnpjRegistration',
  'powerOfAttorney',
  'bankAccountStatement',
];

export const isKeyOfCustomerDocuments = (value: unknown): value is keyof CustomerDocuments => {
  return typeof value === 'string' && propertiesOfCustomerDocuments.includes(value);
};

export const isBusinessInfo = (value: unknown): value is BusinessInfo => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('country' in value && isString(value.country))) return false;
  if (!('commercialName' in value && isStringOrNull(value.commercialName))) return false;
  if (!('legalEntityName' in value && isStringOrNull(value.legalEntityName))) return false;
  if (!('entityType' in value && isEntityTypeOrNull(value.entityType))) return false;
  if (!('taxId' in value && isStringOrNull(value.taxId))) return false;
  if (!('operationStartDate' in value && isStringOrNull(value.operationStartDate))) return false;
  if (!('address' in value && isBusinessAddressOrNull(value.address))) return false;
  if (!('operations' in value && isBusinessOperationsOrNull(value.operations))) return false;
  if (!('socialNetwork' in value && isSocialNetworkOrNull(value.socialNetwork))) return false;
  if (!('organization' in value && isOrganizationOrNull(value.organization))) return false;
  if (!('documents' in value && isCustomerDocumentsOrNull(value.documents))) return false;

  return true;
};

export const isBusinessInfoOrNull = (value: unknown): value is BusinessInfo | null => {
  return value === null || isBusinessInfo(value);
};

export const isArrayOfBusinessInfo = (value: unknown): value is readonly BusinessInfo[] => {
  return Array.isArray(value) && value.every(isBusinessInfo);
};

export const isArrayOfBusinessInfoOrNull = (
  value: unknown,
): value is readonly BusinessInfo[] | null => {
  return value === null || isArrayOfBusinessInfo(value);
};

const propertiesOfBusinessInfo: readonly string[] = [
  'name',
  'country',
  'commercialName',
  'legalEntityName',
  'entityType',
  'taxId',
  'operationStartDate',
  'address',
  'operations',
  'socialNetwork',
  'organization',
  'documents',
];

export const isKeyOfBusinessInfo = (value: unknown): value is keyof BusinessInfo => {
  return typeof value === 'string' && propertiesOfBusinessInfo.includes(value);
};

export const isBusinessDomainAddress = (value: unknown): value is BusinessDomainAddress => {
  if (value === null || typeof value !== 'object') return false;
  if (!('address' in value && isString(value.address))) return false;
  if (!('city' in value && isString(value.city))) return false;
  if (!('geolocation' in value && isString(value.geolocation))) return false;
  if (!('state' in value && isString(value.state))) return false;
  if (!('streetOne' in value && isString(value.streetOne))) return false;
  if (!('streetTwo' in value && isString(value.streetTwo))) return false;
  if (!('zipcode' in value && isString(value.zipcode))) return false;

  return true;
};

export const isBusinessDomainAddressOrNull = (
  value: unknown,
): value is BusinessDomainAddress | null => {
  return value === null || isBusinessDomainAddress(value);
};

export const isArrayOfBusinessDomainAddress = (
  value: unknown,
): value is readonly BusinessDomainAddress[] => {
  return Array.isArray(value) && value.every(isBusinessDomainAddress);
};

export const isArrayOfBusinessDomainAddressOrNull = (
  value: unknown,
): value is readonly BusinessDomainAddress[] | null => {
  return value === null || isArrayOfBusinessDomainAddress(value);
};

const propertiesOfBusinessDomainAddress: readonly string[] = [
  'address',
  'city',
  'geolocation',
  'state',
  'streetOne',
  'streetTwo',
  'zipcode',
];

export const isKeyOfBusinessDomainAddress = (
  value: unknown,
): value is keyof BusinessDomainAddress => {
  return typeof value === 'string' && propertiesOfBusinessDomainAddress.includes(value);
};

export const isBusinessDomainContact = (value: unknown): value is BusinessDomainContact => {
  if (value === null || typeof value !== 'object') return false;
  if (!('firstName' in value && isString(value.firstName))) return false;
  if (!('lastName' in value && isString(value.lastName))) return false;
  if (!('dateOfBirth' in value && isString(value.dateOfBirth))) return false;
  if (!('placeOfBirth' in value && isString(value.placeOfBirth))) return false;
  if (!('citizenship' in value && isString(value.citizenship))) return false;
  if (!('idNumber' in value && isString(value.idNumber))) return false;
  if (!('email' in value && isString(value.email))) return false;
  if (!('phoneNumber' in value && isString(value.phoneNumber))) return false;
  if (!('profession' in value && isString(value.profession))) return false;
  if (!('maritalStatus' in value && isString(value.maritalStatus))) return false;
  if (!('mothersName' in value && isString(value.mothersName))) return false;
  if (!('gender' in value && isString(value.gender))) return false;
  if (!('address' in value && isBusinessDomainAddress(value.address))) return false;
  if (!('industry' in value && isStringOrNull(value.industry))) return false;
  if (!('incomeSource' in value && isStringOrNull(value.incomeSource))) return false;
  if (!('annualIncome' in value && isNumberOrNull(value.annualIncome))) return false;
  if (!('occupation' in value && isStringOrNull(value.occupation))) return false;
  if (!('wealthSource' in value && isStringOrNull(value.wealthSource))) return false;

  return true;
};

export const isBusinessDomainContactOrNull = (
  value: unknown,
): value is BusinessDomainContact | null => {
  return value === null || isBusinessDomainContact(value);
};

export const isArrayOfBusinessDomainContact = (
  value: unknown,
): value is readonly BusinessDomainContact[] => {
  return Array.isArray(value) && value.every(isBusinessDomainContact);
};

export const isArrayOfBusinessDomainContactOrNull = (
  value: unknown,
): value is readonly BusinessDomainContact[] | null => {
  return value === null || isArrayOfBusinessDomainContact(value);
};

const propertiesOfBusinessDomainContact: readonly string[] = [
  'firstName',
  'lastName',
  'dateOfBirth',
  'placeOfBirth',
  'citizenship',
  'idNumber',
  'email',
  'phoneNumber',
  'profession',
  'maritalStatus',
  'mothersName',
  'gender',
  'address',
  'industry',
  'incomeSource',
  'annualIncome',
  'occupation',
  'wealthSource',
];

export const isKeyOfBusinessDomainContact = (
  value: unknown,
): value is keyof BusinessDomainContact => {
  return typeof value === 'string' && propertiesOfBusinessDomainContact.includes(value);
};

export const isBusinessDomain = (value: unknown): value is BusinessDomain => {
  if (value === null || typeof value !== 'object') return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('idNumber' in value && isString(value.idNumber))) return false;
  if (!('address' in value && isBusinessDomainAddress(value.address))) return false;
  if (!('contacts' in value && isArrayOfBusinessDomainContact(value.contacts))) return false;
  if (!('dateOfIncorporation' in value && isString(value.dateOfIncorporation))) return false;
  if (!('email' in value && isString(value.email))) return false;
  if (!('legalStructure' in value && isString(value.legalStructure))) return false;
  if (!('phoneNumber' in value && isString(value.phoneNumber))) return false;
  if (!('website' in value && isString(value.website))) return false;

  return true;
};

export const isBusinessDomainOrNull = (value: unknown): value is BusinessDomain | null => {
  return value === null || isBusinessDomain(value);
};

export const isArrayOfBusinessDomain = (value: unknown): value is readonly BusinessDomain[] => {
  return Array.isArray(value) && value.every(isBusinessDomain);
};

export const isArrayOfBusinessDomainOrNull = (
  value: unknown,
): value is readonly BusinessDomain[] | null => {
  return value === null || isArrayOfBusinessDomain(value);
};

const propertiesOfBusinessDomain: readonly string[] = [
  'name',
  'idNumber',
  'address',
  'contacts',
  'dateOfIncorporation',
  'email',
  'legalStructure',
  'phoneNumber',
  'website',
];

export const isKeyOfBusinessDomain = (value: unknown): value is keyof BusinessDomain => {
  return typeof value === 'string' && propertiesOfBusinessDomain.includes(value);
};

export const isCustomer = (value: unknown): value is Customer => {
  if (value === null || typeof value !== 'object') return false;
  if (!('userId' in value && isString(value.userId))) return false;
  if (!('keycloakId' in value && isString(value.keycloakId))) return false;
  if (!('firstName' in value && isString(value.firstName))) return false;
  if (!('lastName' in value && isString(value.lastName))) return false;
  if (!('email' in value && isString(value.email))) return false;
  if (!('businessInfo' in value && isBusinessInfoOrNull(value.businessInfo))) return false;
  if (!('business' in value && isBusinessDomain(value.business))) return false;
  if (!('benefits' in value && isStringOrNull(value.benefits))) return false;
  if (!('emailVerified' in value && isBoolean(value.emailVerified))) return false;
  if (!('integratorId' in value && isStringOrNull(value.integratorId))) return false;
  if (!('beneficiaryId' in value && isStringOrNull(value.beneficiaryId))) return false;
  if (!('totpEnabled' in value && isBooleanOrNull(value.totpEnabled))) return false;
  if (!('permissions' in value && isArrayOfPermission(value.permissions))) return false;
  if (!('group' in value && isString(value.group))) return false;
  if (!('passwordUpdatable' in value && isBoolean(value.passwordUpdatable))) return false;

  return true;
};

export const isCustomerOrNull = (value: unknown): value is Customer | null => {
  return value === null || isCustomer(value);
};

export const isArrayOfCustomer = (value: unknown): value is readonly Customer[] => {
  return Array.isArray(value) && value.every(isCustomer);
};

export const isArrayOfCustomerOrNull = (value: unknown): value is readonly Customer[] | null => {
  return value === null || isArrayOfCustomer(value);
};

const propertiesOfCustomer: readonly string[] = [
  'userId',
  'keycloakId',
  'firstName',
  'lastName',
  'email',
  'businessInfo',
  'business',
  'benefits',
  'emailVerified',
  'integratorId',
  'beneficiaryId',
  'totpEnabled',
  'permissions',
  'group',
  'passwordUpdatable',
];

export const isKeyOfCustomer = (value: unknown): value is keyof Customer => {
  return typeof value === 'string' && propertiesOfCustomer.includes(value);
};
